import { gql } from '@apollo/client';
import resourceFragment from './resourceFragment';

const GET_RESOURCES = gql`
  query GetResources {
    resources {
      ...resourceFragmentFields
    }
  }

  ${resourceFragment}
`;

export default GET_RESOURCES;
